import { MonthsIndex } from 'core/common/entities';

export const generateDates = (
  startDate: number,
  endDate: number,
  type: 'increment' | 'decrement',
  count = 1,
) => {
  const arrayNumbers = Array.from(
    { length: Math.round((endDate + 1 - startDate) / count) },
    (_, i) => `${startDate + i * count}`,
  );
  if (type === 'decrement') {
    return arrayNumbers.reverse();
  }
  return arrayNumbers;
};

export const generateMonthDays = (month: string, year: string): string[] => {
  let currentMonthDays: number;

  switch (month) {
    case MonthsIndex.JAN:
    case MonthsIndex.MAR:
    case MonthsIndex.MAY:
    case MonthsIndex.JUL:
    case MonthsIndex.AUG:
    case MonthsIndex.OCT:
    case MonthsIndex.DEC:
      currentMonthDays = 31;
      break;
    case MonthsIndex.APR:
    case MonthsIndex.JUN:
    case MonthsIndex.SEP:
    case MonthsIndex.NOV:
      currentMonthDays = 30;
      break;
    case MonthsIndex.FEB:
      currentMonthDays = 28;
      break;
    default:
      currentMonthDays = 31;
  }

  const leapYear = generateDates(1940, 2088, 'increment', 4).includes(year);

  if (leapYear && month === MonthsIndex.FEB) {
    return generateDates(1, 29, 'increment');
  }

  return generateDates(1, currentMonthDays, 'increment');
};
